<div *ngIf="popupName =='Create Email Body for Employment application'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Application Invite Mail to Emp</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <div [innerHTML]="employeeApplicationEmailBody" style="display: none;"></div>
          <!-- 
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
           <span> #EMPLOYEE_NAME#</span><span>  <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."></span>
         
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" class="no-insert"
               (click)="subjectclick('subject')"   maxlength="250" placeholder="Enter Subject Here...">
            </div>
          </mat-form-field>
        </ion-col>


        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12" class="button-container">
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->


          <button (click)="saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content fixed-width"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>


      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <!-- <div>
            <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"></angular-editor>
          </div> -->
          <div>

            <ion-row>
              <ion-col size="12" class="mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')" [ngClass]="'green-bg'">
                  #Salutation#
                </button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')" [ngClass]="'green-bg'">
                  #EmployeeName#
                </button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')" [ngClass]="'green-bg'">
                  #CompanyName#
                </button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmploymentApplicationFormLink#')"
                  [ngClass]="'green-bg'">
                  #EmploymentApplicationFormLink#
                </button>
                <!-- Example of a custom button -->
                <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')" [style.background-color]="'green'">Dear</button> -->
              </ion-col>
            </ion-row>

            <!-- <angular-editor #editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')">
            </angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
            <!-- Instead of *ngIf="condition" -->


          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Create Email Body for Intimation email'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Intimation Mail to HR
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>

            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Create Email Body for offer letter email'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Offer Letter Mail</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>




    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput  type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-col size="12" class="mb-10">
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                [ngClass]="'green-bg'">#Salutation#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                [ngClass]="'green-bg'">#EmployeeName#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CandidateContactNo#')"
                [ngClass]="'green-bg'">#CandidateContactNo#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CandidateEmail#')"
                [ngClass]="'green-bg'">#CandidateEmail#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')"
                [ngClass]="'green-bg'">#Designation#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')"
                [ngClass]="'green-bg'">#Department#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')"
                [ngClass]="'green-bg'">#TodayDate#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Address#')"
                [ngClass]="'green-bg'">#Address#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')"
                [ngClass]="'green-bg'">#HrEmail#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')"
                [ngClass]="'green-bg'">#DateOfJoining#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationCity#')"
                [ngClass]="'green-bg'">#WorkLocationCity#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationState#')"
                [ngClass]="'green-bg'">#WorkLocationState#</button>
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                [ngClass]="'green-bg'">#CompanyName#</button>
              <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')"
                [ngClass]="'green-bg'">#SignaturePath#</button> -->
              <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')"
                [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
            </ion-col>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Create Email Body for Appoinment letter issuance'">
  <div class="cardLayoutTwoapp">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Appointment Letter Mail
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)=" saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class="mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')" [style.background-color]="green">Dear</button> -->
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ProbationPeriod#')"
                  [ngClass]="'green-bg'">#ProbationPeriod#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfBirth#')"
                  [ngClass]="'green-bg'">#DateOfBirth#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeId#')"
                  [ngClass]="'green-bg'">#EmployeeId#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')"
                  [ngClass]="'green-bg'">#Designation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')"
                  [ngClass]="'green-bg'">#TodayDate#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Address#')"
                  [ngClass]="'green-bg'">#Address#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')"
                  [ngClass]="'green-bg'">#HrEmail#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')"
                  [ngClass]="'green-bg'">#DateOfJoining#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationCity#')"
                  [ngClass]="'green-bg'">#WorkLocationCity#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationState#')"
                  [ngClass]="'green-bg'">#WorkLocationState#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')"
                  [ngClass]="'green-bg'">#SignaturePath#</button> -->
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#NoticePeriodDuringProbation#')"
                  [ngClass]="'green-bg'">#NoticePeriodDuringProbation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#NoticePeriodAfterConfirmation#')"
                  [ngClass]="'green-bg'">#NoticePeriodAfterConfirmation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ReportingManagerDesignation#')"
                  [ngClass]="'green-bg'">#ReportingManagerDesignation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')"
                  [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
              </ion-col>
            </ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<!--start Term And Condition -->


<div *ngIf="popupName =='Add term And Condition'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Terms And Condition
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">

              <input matInput type="text" [(ngModel)]="termSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)=" savetermsAndConditon()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>

        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>

                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">
                  #SignaturePath#</button>
              </ion-col>
            </ion-row>

            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="termContent"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<!-- end Term And Condition -->
<div *ngIf="popupName =='Confirmation letter mail with no change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Confirmation Letter Mail(with no change)
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)=" saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
  <ion-col size="12" class="mb-10">
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')" [ngClass]="'green-bg'">#Salutation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')" [ngClass]="'green-bg'">#EmployeeName#</button>
    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')" [style.background-color]="green">Dear</button> -->
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')" [ngClass]="'green-bg'">#Designation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')" [ngClass]="'green-bg'">#Department#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')" [ngClass]="'green-bg'">#TodayDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')" [ngClass]="'green-bg'">#DateOfJoining#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfConfirmation#')" [ngClass]="'green-bg'">#DateOfConfirmation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')" [ngClass]="'green-bg'">#CompanyName#</button>
    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">#SignaturePath#</button> -->
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')" [ngClass]="'green-bg'">#HrEmail#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')" [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
  </ion-col>
</ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='confirmation with change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Confirmation Letter Mail(with change)
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
          <ion-row>
  <ion-col size="12" class="mb-10">
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')" [ngClass]="'green-bg'">#Salutation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')" [ngClass]="'green-bg'">#EmployeeName#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')" [ngClass]="'green-bg'">#Designation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')" [ngClass]="'green-bg'">#Department#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')" [ngClass]="'green-bg'">#TodayDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfConfirmation#')" [ngClass]="'green-bg'">#DateOfConfirmation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')" [ngClass]="'green-bg'">#DateOfJoining#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')" [ngClass]="'green-bg'">#CompanyName#</button>
    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">#SignaturePath#</button> -->
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')" [ngClass]="'green-bg'">#HrEmail#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')" [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
  </ion-col>
</ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Extention of probation letter mail'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Extention of Probation Letter Mail
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
           <ion-row>
  <ion-col size="12" class="mb-10">
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')" [ngClass]="'green-bg'">#Salutation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')" [ngClass]="'green-bg'">#EmployeeName#</button>
    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')" [style.background-color]="green">Dear</button> -->
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')" [ngClass]="'green-bg'">#Designation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')" [ngClass]="'green-bg'">#Department#</button>
     <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')" [ngClass]="'green-bg'">#CompanyName#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ExtensionDayMonths#')" [ngClass]="'green-bg'">#ExtensionDayMonths#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')" [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')" [ngClass]="'green-bg'">#TodayDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')" [ngClass]="'green-bg'">#DateOfJoining#</button>
    
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ProbationExtensionEndDate#')" [ngClass]="'green-bg'">#ProbationExtensionEndDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ImprovementPoints#')" [ngClass]="'green-bg'">#ImprovementPoints#</button>
   
    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">#SignaturePath#</button> -->
  </ion-col>
</ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv" 
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Create Email Body Reliving/Experience mail'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular"> Reliving/Experience Mail
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>

        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                 <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#LWD#')"
                  [ngClass]="'green-bg'">#LWD#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ResignationDate#')"
                  [ngClass]="'green-bg'">#ResignationDate#</button>
                     <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')"
                  [ngClass]="'green-bg'">#HrEmail#</button>
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Create Email Body for Termination Mail'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Termination Mail
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>

        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
           <ion-row>
              <ion-col size="12" class=" mb-10">
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                 <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#LWD#')"
                  [ngClass]="'green-bg'">#LWD#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TerminationDate#')"
                  [ngClass]="'green-bg'">#TerminationDate#</button>
                     <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')"
                  [ngClass]="'green-bg'">#HrEmail#</button>
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv"
              [(ngModel)]="employeeApplicationEmailBody" (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>


<div *ngIf="popupName =='Create offer letter content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Offer Letter Content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
             (click)="subjectclick('subject')"   maxlength="250">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <!-- <button *ngIf="!isPublished" (click)="saveMailContentdata()" type="button"
              class="add_btn fs-14 fs_12ForMobile float-right center-content" [style.background-color]="buttonColorName">
              <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
              Save
            </button> -->
          <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width" (click)=" saveMailContentdata()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class="mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CandidateContactNo#')"
                  [ngClass]="'green-bg'">#CandidateContactNo#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CandidateEmail#')"
                  [ngClass]="'green-bg'">#CandidateEmail#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')"
                  [ngClass]="'green-bg'">#Designation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')"
                  [ngClass]="'green-bg'">#TodayDate#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Address#')"
                  [ngClass]="'green-bg'">#Address#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')"
                  [ngClass]="'green-bg'">#HrEmail#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')"
                  [ngClass]="'green-bg'">#DateOfJoining#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationCity#')"
                  [ngClass]="'green-bg'">#WorkLocationCity#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationState#')"
                  [ngClass]="'green-bg'">#WorkLocationState#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')"
                  [ngClass]="'green-bg'">#SignaturePath#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')"
                  [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
              </ion-col>
            </ion-row>

            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig"
              (click)="subjectclick('body')"></jodit-editor>




            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody" (click)="subjectclick('body')"></angular-editor> -->
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>


<div *ngIf="popupName =='Create Appoinment letter content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Appointment Letter Content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
             (click)="subjectclick('subject')"   maxlength="250">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMailContentdata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class="mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')" [style.background-color]="green">Dear</button> -->
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ProbationPeriod#')"
                  [ngClass]="'green-bg'">#ProbationPeriod#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfBirth#')"
                  [ngClass]="'green-bg'">#DateOfBirth#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeId#')"
                  [ngClass]="'green-bg'">#EmployeeId#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')"
                  [ngClass]="'green-bg'">#Designation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')"
                  [ngClass]="'green-bg'">#TodayDate#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Address#')"
                  [ngClass]="'green-bg'">#Address#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')"
                  [ngClass]="'green-bg'">#HrEmail#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')"
                  [ngClass]="'green-bg'">#DateOfJoining#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationCity#')"
                  [ngClass]="'green-bg'">#WorkLocationCity#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationState#')"
                  [ngClass]="'green-bg'">#WorkLocationState#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')"
                  [ngClass]="'green-bg'">#SignaturePath#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#NoticePeriodDuringProbation#')"
                  [ngClass]="'green-bg'">#NoticePeriodDuringProbation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#NoticePeriodAfterConfirmation#')"
                  [ngClass]="'green-bg'">#NoticePeriodAfterConfirmation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ReportingManagerDesignation#')"
                  [ngClass]="'green-bg'">#ReportingManagerDesignation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')"
                  [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
              </ion-col>
            </ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig"
              (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Confirmation letter content with no change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Confirmation Letter Content With no Change</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
             (click)="subjectclick('subject')"   maxlength="250">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMailContentdata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
          <ion-row>
  <ion-col size="12" class="mb-10">
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')" [ngClass]="'green-bg'">#Salutation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')" [ngClass]="'green-bg'">#EmployeeName#</button>
    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')" [style.background-color]="green">Dear</button> -->
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')" [ngClass]="'green-bg'">#Designation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')" [ngClass]="'green-bg'">#Department#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')" [ngClass]="'green-bg'">#TodayDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')" [ngClass]="'green-bg'">#DateOfJoining#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfConfirmation#')" [ngClass]="'green-bg'">#DateOfConfirmation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')" [ngClass]="'green-bg'">#CompanyName#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">#SignaturePath#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')" [ngClass]="'green-bg'">#HrEmail#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')" [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
  </ion-col>
</ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig"
              (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Confirmation letter content with change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Confirmation Letter Content With Change</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
             (click)="subjectclick('subject')"   maxlength="250">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMailContentdata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
          <ion-row>
  <ion-col size="12" class="mb-10">
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')" [ngClass]="'green-bg'">#Salutation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')" [ngClass]="'green-bg'">#EmployeeName#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')" [ngClass]="'green-bg'">#Designation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')" [ngClass]="'green-bg'">#Department#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')" [ngClass]="'green-bg'">#TodayDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfConfirmation#')" [ngClass]="'green-bg'">#DateOfConfirmation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')" [ngClass]="'green-bg'">#DateOfJoining#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')" [ngClass]="'green-bg'">#CompanyName#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">#SignaturePath#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')" [ngClass]="'green-bg'">#HrEmail#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')" [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
  </ion-col>
</ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig"
              (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Extention of probation content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Extention of Probation Content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
             (click)="subjectclick('subject')"   maxlength="250">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMailContentdata()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
    <ion-row>
  <ion-col size="12" class="mb-10">
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')" [ngClass]="'green-bg'">#Salutation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')" [ngClass]="'green-bg'">#EmployeeName#</button>
    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('Dear')" [style.background-color]="green">Dear</button> -->
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')" [ngClass]="'green-bg'">#Designation#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')" [ngClass]="'green-bg'">#Department#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')" [ngClass]="'green-bg'">#CompanyName#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ExtensionDayMonths#')" [ngClass]="'green-bg'">#ExtensionDayMonths#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AnnualTotalCtc#')" [ngClass]="'green-bg'">#AnnualTotalCtc#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')" [ngClass]="'green-bg'">#TodayDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')" [ngClass]="'green-bg'">#DateOfJoining#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ProbationExtensionEndDate#')" [ngClass]="'green-bg'">#ProbationExtensionEndDate#</button>
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ImprovementPoints#')" [ngClass]="'green-bg'">#ImprovementPoints#</button>
    
    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">#SignaturePath#</button>
  </ion-col>
</ion-row>

            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig"
              (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Reliving/Experience letter content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Reliving/Experience Letter Content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
             (click)="subjectclick('subject')"   maxlength="250">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <!-- <button *ngIf="!isPublished" (click)="saveMailContentdata()" type="button"
              class="add_btn fs-14 fs_12ForMobile float-right center-content" [style.background-color]="buttonColorName">
              <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
              Save
            </button> -->
          <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width" (click)=" saveMailContentdata()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
         <ion-row>
              <ion-col size="12" class="mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
               
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')"
                  [ngClass]="'green-bg'">#Designation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#IssuedDate#')"
                  [ngClass]="'green-bg'">#IssuedDate#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#LWD#')"
                  [ngClass]="'green-bg'">#LWD#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
                <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AssetHandoverStatus#')"
                  [ngClass]="'green-bg'">#AssetHandoverStatus#</button> -->
                    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ReasonforLeaving#')"
                  [ngClass]="'green-bg'">#ReasonforLeaving#</button>
                   <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ReportingManagerName#')"
                  [ngClass]="'green-bg'">#ReportingManagerName#</button>
                   <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmploymentType#')"
                  [ngClass]="'green-bg'">#EmploymentType#</button>
                      <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ResignationDate#')"
                  [ngClass]="'green-bg'">#ResignationDate#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')"
                  [ngClass]="'green-bg'">#DateOfJoining#</button>  
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')"
                  [ngClass]="'green-bg'">#SignaturePath#</button>
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HRVerificationStatus#')"
                  [ngClass]="'green-bg'">#HRVerificationStatus#</button>
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TenureDuration#')"
                  [ngClass]="'green-bg'">#TenureDuration#</button>
              </ion-col>
            </ion-row>
            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig"
              (click)="subjectclick('body')"></jodit-editor>




            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody" (click)="subjectclick('body')"></angular-editor> -->
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Termination letter content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Termination Letter Content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
             (click)="subjectclick('subject')"   maxlength="250">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
       
          <button type="button" class="add_btn fs-14 fs_12ForMobile fixed-width" (click)=" saveMailContentdata()">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
              <ion-row>
              <ion-col size="12" class="mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
               
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Designation#')"
                  [ngClass]="'green-bg'">#Designation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#IssuedDate#')"
                  [ngClass]="'green-bg'">#IssuedDate#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#LWD#')"
                  [ngClass]="'green-bg'">#LWD#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')" [ngClass]="'green-bg'">#EmployeeCode#</button>
                <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#AssetHandoverStatus#')"
                  [ngClass]="'green-bg'">#AssetHandoverStatus#</button> -->
                    <!-- <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ReasonforLeaving#')"
                  [ngClass]="'green-bg'">#ReasonforLeaving#</button> -->
                   <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ReportingManagerName#')"
                  [ngClass]="'green-bg'">#ReportingManagerName#</button>
                   <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmploymentType#')"
                  [ngClass]="'green-bg'">#EmploymentType#</button>
                      <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TerminationDate#')"
                  [ngClass]="'green-bg'">#TerminationDate#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DateOfJoining#')"
                  [ngClass]="'green-bg'">#DateOfJoining#</button>  
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')"
                  [ngClass]="'green-bg'">#SignaturePath#</button>
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HRVerificationStatus#')"
                  [ngClass]="'green-bg'">#HRVerificationStatus#</button>
               <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TenureDuration#')"
                  [ngClass]="'green-bg'">#TenureDuration#</button>
              </ion-col>
            </ion-row>

            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig"
              (click)="subjectclick('body')"></jodit-editor>




            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody" (click)="subjectclick('body')"></angular-editor> -->
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<!-- ---------------------------------------------------------Increment --------------------------------------------------------- -->

<!--start Add term And Condition for increment -->


<div *ngIf="popupName =='Add term And Condition for increment'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Terms And Condition
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">

              <input matInput type="text" [(ngModel)]="termSubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)=" savetermsAndConditon()" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName"  [disabled]="isDisabledIncrementLetter" [ngClass]="{ 'disable': isDisabledIncrementLetter }">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>

        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>

                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')" [ngClass]="'green-bg'">
                  #SignaturePath#</button>
              </ion-col>
            </ion-row>

            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="termContent"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<!-- end Add term And Condition for increment -->





<!-- ----------------------------------------------------------------------------------Landing Page---------------------------------------- -->

<div *ngIf="popupName =='Create Email Body for landing page'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Birthday Wishes
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">
      <!-- <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Mail From:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">

              <input matInput type="text" [(ngModel)]="letterContentFromBirthday" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>


      </ion-row> -->
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">

              <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMailContentdata()" type="button" class="add_btn fs-14 float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>

        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Logo#')" [ngClass]="'green-bg'">#Logo#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Twitter#')"
                  [ngClass]="'green-bg'">#Twitter#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Linkedin#')"
                  [ngClass]="'green-bg'">#Linkedin#</button>
              </ion-col>
            </ion-row>

            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Create Email Body for anniversary wishes'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Work Anniversary
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo" id="lcmMail">

      <!-- <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold"> Mail From:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">

              <input matInput type="text" [(ngModel)]="letterContentFromAnniversaries"
                placeholder="Enter Subject Here..."(click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>


      </ion-row> -->
      <ion-row class="verticle-center mt-10">

        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">

          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">

              <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
               (click)="subjectclick('subject')"   maxlength="250">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMailContentdata()" type="button" class="add_btn fs-14 float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>

        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#Salutation#')"
                  [ngClass]="'green-bg'">#Salutation#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#EmployeeName#')"
                  [ngClass]="'green-bg'">#EmployeeName#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#CompanyName#')"
                  [ngClass]="'green-bg'">#CompanyName#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Logo#')" [ngClass]="'green-bg'">#Logo#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Twitter#')"
                  [ngClass]="'green-bg'">#Twitter#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Linkedin#')"
                  [ngClass]="'green-bg'">#Linkedin#</button>

              </ion-col>
            </ion-row>

            <jodit-editor [config]="editorConfig" id="htmlDiv" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>